const CJK_PATTERN = /[぀-ヿ㐀-䶿一-鿿豈-﫿ｦ-ﾟ가-힯]/;

/** True if the string contains any Chinese, Japanese, or Korean character. */
export function hasCJK(str: string): boolean {
	return CJK_PATTERN.test(str);
}

/**
 * Format a person's full name based on script.
 * CJK names render last-first with no separator; everything else renders
 * first-last with a space.
 */
export function formatFullName({
	firstName,
	lastName,
}: {
	firstName: string;
	lastName: string;
}): string {
	return hasCJK(firstName) || hasCJK(lastName)
		? `${lastName}${firstName}`
		: `${firstName} ${lastName}`;
}

/**
 * Compact avatar label. For CJK names we use the last name as-is (one or two
 * glyphs reads cleanly); for western names we use the first letter of each.
 */
export function getInitials(firstName: string, lastName: string): string {
	if (hasCJK(lastName)) return lastName;
	return (firstName[0]?.toUpperCase() ?? "") + (lastName[0]?.toUpperCase() ?? "");
}
